// extracted by mini-css-extract-plugin
export var included = "included-module--included--2BEjk";
export var included__second = "included-module--included__second--1tQmJ";
export var included__wrap = "included-module--included__wrap--3GQbq";
export var included__section = "included-module--included__section--3jB4I";
export var included__section__image = "included-module--included__section__image--8a062";
export var info__section__image__bg = "included-module--info__section__image__bg--_g0ql";
export var included__section__image__bg = "included-module--included__section__image__bg--3OnEZ";